export const PrioridadesActionTypes = {
  API_RESPONSE_SUCCESS: '@@prioridad-incidencias/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@prioridad-incidencias/API_RESPONSE_ERROR',

  // GET_PRIORIDAD: '@@prioridad-incidencias/GET_PRIORIDAD',
  LIST_PRIORIDADES: '@@prioridad-incidencias/LIST_PRIORIDADES',
  // ADD_PRIORIDAD: '@@prioridad-incidencias/ADD_PRIORIDAD',
  // UPDATE_PRIORIDAD: '@@prioridad-incidencias/UPDATE_PRIORIDAD',
  // DELETE_PRIORIDAD: '@@prioridad-incidencias/DELETE_PRIORIDAD',

  RESET: '@@prioridad-incidencias/RESET'
}
